import {
	faCaretDown,
	faCaretUp,
	IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import {
	Accordion,
	AccordionItem,
	AccordionItemButton,
	AccordionItemHeading,
	AccordionItemPanel,
} from 'react-accessible-accordion';
import './Accordion.scss';

interface AccordionProps {
	title: string;
	children: JSX.Element;
}

export const AccordionBanner = ({ title, children }: AccordionProps) => {
	const [icon, setIcon] = useState(faCaretDown);
	return (
		<Accordion
			allowMultipleExpanded={true}
			allowZeroExpanded={true}
			onChange={(args) => {
				if (args.length < 1) setIcon(faCaretDown);
				else setIcon(faCaretUp);
			}}
		>
			<AccordionItem
				className="accordion-card-container"
				style={{ border: '0px' }}
			>
				<AccordionItemHeading>
					<AccordionItemButton>
						<AccordionBannerHeader title={title} icon={icon} />
					</AccordionItemButton>
				</AccordionItemHeading>
				<AccordionItemPanel>{children}</AccordionItemPanel>
			</AccordionItem>
		</Accordion>
	);
};

export const AccordionBannerHeader = ({
	title,
	icon,
}: {
	title: string;
	icon: IconDefinition;
}) => {
	return (
		<div
			className="row justify-content-md-between"
			style={{
				width: '98%',
				paddingTop: 20,
				paddingBottom: 20,
				paddingLeft: 15,
			}}
		>
			<div className="col-6 col-md-9 d-flex flex-column">
				<button
					className="h6 link-text text-left"
					style={{
						background: 'transparent',
						border: '0px',
						color: '#224c98',
					}}
				>
					{title}
				</button>
			</div>
			<div className="col-1 col-md-1 d-flex flex-column">
				<FontAwesomeIcon color="#224c98" icon={icon} size="lg" />
			</div>
		</div>
	);
};
